import React, { useState } from "react";
import { IoMdMap, IoMdClose } from "react-icons/io";
import "./map-popup.css";
import { useTranslation } from "react-i18next";
import MapPinImage from "../../Assets/MapPin2.jpg";

export default function MapPopup() {
  const [open, setOpen] = useState(false);
  const { i18n } = useTranslation("");

  return (
    <>
      <button onClick={() => setOpen(true)} className="map-popup-button">
        <IoMdMap />
        <span>{i18n.language === "sr" ? "Mapa" : "Map"}</span>
      </button>
      <div
        className={`map-popup ${open ? "open" : ""}`}
        onClick={() => setOpen(false)}
      >
        <button className="map-popup-close" onClick={() => setOpen(false)}>
          <IoMdClose />
        </button>
        <div className="map-popup-content" onClick={(e) => e.stopPropagation()}>
          <img src={MapPinImage} alt="Slika mape puteva." />
          <div className="map-popup-item">
            <span className="dot red"></span>
            <p>
              {i18n.language === "sr"
                ? "Crveno – put zatvoren"
                : "Red – road closed"}
            </p>
          </div>
          <div className="map-popup-item">
            <span className="dot green"></span>
            <p>
              {i18n.language === "sr"
                ? "Zeleno - drugi prilaz restoranu"
                : "Green – alternative access to the restaurant"}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
